import React from 'react';
import {Rings} from 'react-loader-spinner';
import {Backdrop} from '@mui/material';

export const PWMLoadingIndicator: React.FC<ISpinnerProps> = (props) => {
  return (
    <Backdrop open={props.spin} sx={{zIndex: 50000000}}>
      <Rings color="blue"/>
    </Backdrop>
  );
}
interface ISpinnerProps {
  spin: boolean;
}